import type { Models } from '@rematch/core';

// Stores
import { auth } from './auth';
import { user } from './user';
import { organizations } from './organizations';
import { controllers } from './controllers';
import { locations } from './locations';
import { members } from './members';
import { contracts } from './contracts';
import { cycles } from './cycles';
import { note } from './note';
import { screens } from './screens';
import { channels } from './channels';
import { reports } from './reports';
import { recipes } from './recipes';
import { chart_preference } from './chart-preference';
import { calibration_certificates } from './calibration-certificates';
import { contract_meta_fields } from './contract-meta-fields';
import { report_meta_fields } from './report-meta-fields';
import { location_meta_fields } from './location-meta-fields';
import { pre_heat_recipes } from './pre-heat-recipes';
import { edit_mode } from './edit-mode';
export interface RootModel extends Models<RootModel> {
  auth: typeof auth;
  user: typeof user;
  organizations: typeof organizations;
  controllers: typeof controllers;
  locations: typeof locations;
  members: typeof members;
  contracts: typeof contracts;
  cycles: typeof cycles;
  note: typeof note;
  screens: typeof screens;
  channels: typeof channels;
  reports: typeof reports;
  recipes: typeof recipes;
  chart_preference: typeof chart_preference;
  calibration_certificates: typeof calibration_certificates;
  contract_meta_fields: typeof contract_meta_fields;
  report_meta_fields: typeof report_meta_fields;
  location_meta_fields: typeof location_meta_fields;
  pre_heat_recipes: typeof pre_heat_recipes;
  edit_mode: typeof edit_mode;
}

export const models: RootModel = {
  auth,
  user,
  organizations,
  controllers,
  locations,
  members,
  contracts,
  cycles,
  note,
  screens,
  channels,
  reports,
  recipes,
  chart_preference,
  calibration_certificates,
  contract_meta_fields,
  report_meta_fields,
  location_meta_fields,
  pre_heat_recipes,
  edit_mode,
};
